export const RAW_COLORS = {
  primary: {
    glow: '#ff438c',
    cosmos: '#6000fe',
    pulse: '#C935FF',
    flare: '#FF006C',
    corona: '#c10b5e',
    nova: '#F55A4F',
    aurora: '#4800A7',
    drift: '#2B4BD6',
    ion: '#00BBEA',
    nebula: '#00E79A',
    solar: '#f1b42f',
  },
  secondary: {
    spark: '#f8727d',
    ember: '#f64555',
    surge: '#e00b1c',
    haze: '#f5d07e',
    dust: '#94680a',
    halcyon: '#53d1c2',
    abyss: '#28807e',
    prism: '#849cf5',
    ether: '#ba95f9',
    void: '#463b68',
    vapor: '#B8D8FF',
    wave: '#7749f8',
    umbra: '#F47147',
    plasma: '#F3873F',
    eclipse: '#25307A',
  },

  neutral: {
    neutral10: '#fbfafb',
    neutral20: '#e6e4ea',
    neutral30: '#aeabb6',
    neutral40: '#8d8997',
    neutral50: '#656074',
    neutral60: '#514C63',
    neutral70: '#3d3751',
    neutral80: '#2c2541',
    orbit: '#1c1533',
    black: '#000000',
    halo: '#ffffff',
    transparent: '#00000000',
    zenith: '#F5F5F5',
    shadowOverlayDark: 'rgba(0, 0, 0, 0.45)',
    shadowOverlayLight: 'rgba(0, 0, 0, 0.15)',
    innerShadowDark: 'rgba(230, 228, 234, 0.3)',
    innerShadowLight: 'rgba(163, 163, 163, 0.3)',
  },

  // Bespoke atmospheric palette for the full-screen landing/login page.
  login: {
    voidDeep: '#0a0518',
    nebulaHaze: '#2a1f4a',
    voidAbyss: '#13092a',
  },
}

export const GRADIENTS = {
  veil: `linear-gradient(90deg, ${RAW_COLORS.secondary.wave} 0%, ${RAW_COLORS.primary.drift} 35%, ${RAW_COLORS.primary.ion} 70%, ${RAW_COLORS.primary.nebula} 100%)`,
  heat: `linear-gradient(90deg, ${RAW_COLORS.primary.pulse} 0%, ${RAW_COLORS.primary.flare} 50%, ${RAW_COLORS.primary.nova} 100%)`,
  spectrum: `linear-gradient(90deg, ${RAW_COLORS.primary.solar} 0%, ${RAW_COLORS.primary.nova} 17%, ${RAW_COLORS.primary.flare} 34%, ${RAW_COLORS.primary.pulse} 50%, ${RAW_COLORS.primary.drift} 67%, ${RAW_COLORS.secondary.eclipse} 84%, ${RAW_COLORS.neutral.orbit} 100%)`,
  rise: `linear-gradient(90deg, ${RAW_COLORS.primary.solar} 0%, ${RAW_COLORS.primary.nova} 35%, ${RAW_COLORS.primary.flare} 70%, ${RAW_COLORS.primary.pulse} 100%)`,
  // Starts at aurora (not orbit) so the leftmost gradient text stays readable on dark backgrounds.
  set: `linear-gradient(90deg, ${RAW_COLORS.primary.aurora} 0%, ${RAW_COLORS.primary.drift} 40%, ${RAW_COLORS.primary.ion} 75%, ${RAW_COLORS.primary.nebula} 100%)`,
  dawn: `linear-gradient(90deg, ${RAW_COLORS.neutral.zenith} 0%, ${RAW_COLORS.secondary.plasma} 35%, ${RAW_COLORS.primary.nova} 70%, ${RAW_COLORS.primary.flare} 100%)`,
  dusk: `linear-gradient(90deg, ${RAW_COLORS.neutral.orbit} 0%, ${RAW_COLORS.secondary.eclipse} 40%, ${RAW_COLORS.primary.aurora} 100%)`,
  daylight: `linear-gradient(90deg, ${RAW_COLORS.neutral.zenith} 0%, ${RAW_COLORS.secondary.umbra} 100%)`,
  midnight: `linear-gradient(90deg, ${RAW_COLORS.neutral.orbit} 0%, ${RAW_COLORS.secondary.eclipse} 85%, ${RAW_COLORS.primary.aurora} 100%)`,
}
